import { userRequest } from "../../../../userRequest";
import { ModalQrCodeProtegido } from "../modal/modalQrCodeProtegido";

export const ModalAutenticador = ({ visible, onCancel }) => (
  <ModalQrCodeProtegido
    visible={visible}
    onCancel={onCancel}
    titulo="QR Code do HelpSystem"
    avisoMensagem="Este QR Code é o seu segundo fator de acesso ao HelpSystem"
    avisoDescricao="Quem fotografar a tela consegue gerar seus códigos de login. Escaneie apenas no seu próprio celular e não compartilhe a imagem."
    buscarQrCode={userRequest.getAuthenticator}
    mensagemErro="Não foi possível gerar o QR Code do autenticador."
  />
);
